export default {
  setCurrentToken(token) {
    this.currentToken = token
  },
  setPayload(payload) {
    this.payload = payload
  },
  setCurrentPartner(token) {
    this.currentPartner = token
  },
  setAppTranslations(translations) {
    this.appTranslations = translations
  }
}
